<template>
  <div class="flex flex-col">
    <div class="grow flex flex-col px-4 py-8">
      <FormKit
          type="form"
          :actions="false"
          @submit="submitHandler"
          @node="onFormNode"
      >
        <FormKit
            type="text"
            name="postalcode"
            label="Enter service address ZIP code"
            :validation="config.public.zipValidationRule"
            v-model="postalCode"
            inputmode="numeric"
            placeholder="Type here..."
            autofocus
        />
      </FormKit>
      <Errormgs v-if="FMStore?.error" :mgs="FMStore?.errorMessage"/>
    </div>
    <Buttons>
      <Button class="btn btn__primary" :disabled="disabled" :loading="isLoading"
              @click="submitHandler">
        Continue
      </Button>
    </Buttons>
  </div>
</template>
<script setup lang="ts">
import {ref, watch, watchEffect} from "vue";
import Button from "~/components/ui/Button.vue";
import Buttons from "~/components/ui/Buttons.vue";
import Errormgs from "~/components/ui/Errormgs.vue";

const config = useRuntimeConfig()
import {useFMStore} from "~/store/FMStore";

const FMStore = useFMStore();
const disabled = ref(true);
const postalCode = ref(null);
const isLoading = ref(false);
const formNode = ref(null);

const onFormNode = (node) => {
  formNode.value = node
}
watchEffect(() => {
  if (formNode.value?.context?.state) {
    disabled.value = !formNode.value.context.state.valid
  }
})

function isPostalCodeValid(postalCode) {
  // Check if the postal code is in the array
  if (FMStore.postalCodes.includes(postalCode.value)) {
    disabled.value = false;
    return true;
  }
  disabled.value = true;
  return false;

}

async function submitHandler() {
  isLoading.value = true;
  await FMStore.resetError();
  if (isPostalCodeValid(postalCode)) {
    await FMStore.getWorkOrders(postalCode.value).then(() => {
      FMStore.stepNumber++;
      FMStore.goToStep('Selectaddress');
    });
  } else {
    FMStore.error = true;
    FMStore.errorMessage =
        "It looks like there's nothing to schedule in this postal code. Please visit the website below for more information.";
  }
  isLoading.value = false;
}
</script>
